goog.provide("shadow.js.shim.module$openseadragon");
goog.provide("module$shadow_js_shim_module$openseadragon");
shadow.js.shim.module$openseadragon = shadow.js.nativeProvides["openseadragon"] = shadow$bridge("openseadragon");
module$shadow_js_shim_module$openseadragon.default = shadow.js.shim.module$openseadragon;
